// extracted by mini-css-extract-plugin
export default {"EmptyState":"EmptyState_EmptyState__ma7ZD"};